import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Image } from 'react-bootstrap';
import castelloConegliano from '../../assets/palindromo/01.jpg';
import castelloConegliano2 from '../../assets/palindromo/02.jpg';
import preview from '../../assets/preview.jpg';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import RandomXAnimation from '../../assets/palindromo/RandomXAnimation.jsx';
import HeroTedx2026 from '../../assets/palindromo/HeroTedx2026.jsx';

import AndreaImpiombato from '../../assets/palindromo/Speaker/01_Andrea Impiombato Andreani_Web.png';
import DomingaLot from '../../assets/palindromo/Speaker/02_Dominga Lot_Web.png';
import ElisabettaModena from '../../assets/palindromo/Speaker/03_Elisabetta Modena_Web.png';
import GermanoMilite from '../../assets/palindromo/Speaker/04_Germano Milite_Web.png';
import MariaRosaDiFazio from '../../assets/palindromo/Speaker/05_Maria Rosa di Fazio_Web.png';
import MassimoColomban from '../../assets/palindromo/Speaker/06_Massimo Colomban_Web.png';
import MichelaPossamai from '../../assets/palindromo/Speaker/07_Michela Possamai_Web.png';
import NicolaGirotti from '../../assets/palindromo/Speaker/08_Nicola Girotti_Web.png';
import PaoloCasarini from '../../assets/palindromo/Speaker/09_Paolo Casarini_Web.png';
import SaraFabbroni from '../../assets/palindromo/Speaker/10_Sara Fabbroni_Web.png';
import SaraDallArmellina from '../../assets/palindromo/Speaker/11_Sara Dall Armellina_Web.png';
import GraziaGrena from '../../assets/palindromo/Speaker/12_Grazia Grena_Web.png';



export default function Palindromo() {

    const cache0 = {};
    function importAll0(r) {
        r.keys().forEach((key) => (cache0[key] = r(key)));
    }
    importAll0(require.context("../../assets/palindromo/00_Main/", false, /\.(png|jpe?g|svg)$/));
    const logos0 = Object.entries(cache0).map(module => module[1]);


    const cache1 = {};
    function importAll1(r) {
        r.keys().forEach((key) => (cache1[key] = r(key)));
    }
    importAll1(require.context("../../assets/palindromo/01_Partner/", false, /\.(png|jpe?g|svg)$/));
    const logos1 = Object.entries(cache1).map(module => module[1]);


    const cache2 = {};
    function importAll2(r) {
        r.keys().forEach((key) => (cache2[key] = r(key)));
    }
    importAll2(require.context("../../assets/palindromo/02_Technical/", false, /\.(png|jpe?g|svg)$/));
    const logos2 = Object.entries(cache2).map(module => module[1]);


    const cache3 = {};
    function importAll3(r) {
        r.keys().forEach((key) => (cache3[key] = r(key)));
    }
    importAll3(require.context("../../assets/palindromo/03_Patrocinio/", false, /\.(png|jpe?g|svg)$/));
    const logos3 = Object.entries(cache3).map(module => module[1]);



    return (
        <>
            <Helmet>
                <title>Palindromo</title>
                <meta name="description" content="TEDxConegliano - Edizione: Palindromo" />
            </Helmet>


            <HeroTedx2026 ticketUrl="https://www.eventbrite.it/e/biglietti-tedxconegliano-palindromo-1982234216903" />

            {/* Hero precedente — sostituita da <HeroTedx2026 />. Tenuta commentata
                come backup nel caso il nuovo componente vada rimpiazzato.
            <Container fluid className='mt-0 pt-0 ps-0 pe-0 bg-slide height-100 slide-gradient-light align-items-end' style={{ backgroundSize: 'inherit', backgroundRepeat: 'repeat', backgroundColor: '#000' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <h5>2026</h5>
                    <h1 className='mt-5 mb-5' style={{ maxWidth: 700 }}>
                        PALINDROMO - Apparente uguale, reale diverso.<br />
                        27 Giugno 2026
                    </h1>

                    <p className='lead' style={{ maxWidth: 700 }}>
                    Ciò che sembra uguale non lo è mai davvero.<br/>
                    Ogni forma contiene più letture, ogni idea più direzioni.<br/>
                    Con questa edizione di TEDxConegliano esploriamo come il significato cambi a seconda di come lo attraversiamo, perché basta uno spostamento, anche minimo, per vedere qualcosa di completamente diverso.

                    </p>

                    <div className='mt-5 mb-5'>
                        <a href="https://www.eventbrite.it/e/biglietti-tedxconegliano-palindromo-1982234216903" target="_blank">
                            <span className='button-52-light m-auto'>
                                Acquista biglietto
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>
            */}


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 height-100'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={5}>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                            <h3 className='mt-5 mb-5' style={{ maxWidth: 700 }}>
                                Cosa significa palindromo per noi?
                            </h3>

                            <p className='mb-5 lead'>
                                Palindromo è ciò che può essere letto in più direzioni.<br/>
                                Ciò che resta uguale nella forma, ma cambia nel significato.<br/>
                                Idee, percorsi, storie che non hanno un solo verso e che, proprio per questo, aprono possibilità inattese.

                            </p>

                            <p className='mb-5'>
                                Per raccontarlo, partiamo da un centro comune.<br/>
                                Una struttura che rimane, mentre tutto intorno si trasforma.<br/>
                                Avvicinandosi, le interpretazioni si moltiplicano.<br/>
                                Ogni elemento resta lo stesso, ma il modo in cui lo leggiamo cambia.<br/>
                                È in questo spazio, tra forma e significato, che prende vita questa edizione: 
                                un invito a rileggere ciò che pensavamo di conoscere.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={6} className='text-center'>
                            <RandomXAnimation size={'100%'} color="#eb0028" bg="transparent" />
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-black' style={{ backgroundColor: '#000' }}>
                <Container fluid="md" className='text-start p-5 text-white' style={{ zIndex: 1 }}>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={2} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h3>
                                Vogliamo cambiare il modo in cui guardi ciò che credi di conoscere.
                            </h3>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={5} className='pb-5'>
                            <p className='lead'>
                                A scoprire che ogni idea può avere più direzioni.<br/>
                                Che ciò che appare definito può cambiare significato, semplicemente cambiando il punto da cui lo attraversiamo.
                            </p>
                            <p>
                                Ci sono percorsi che non hanno un solo verso.<br/>
                                E proprio per questo aprono nuove possibilità.<br/>
                                Palindromo è questo spazio: un invito a riconoscere che non è la forma a cambiare, ma il modo in cui scegliamo di leggerla.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100' style={{ backgroundColor: '#eb0028' }}>
                <Container fluid="md" className='text-center p-5 text-white' style={{ zIndex: 1 }}>

                    <div className='d-flex justify-content-center'>
                        <RandomXAnimation size={350} color="#ffffff" bg="transparent" />
                    </div>

                    <h1 className='mt-5 mb-5'>
                        Stesso punto di partenza. Nuovi significati.
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Un invito a guardare ancora.<br/>
                        A cambiare direzione, senza cambiare luogo.<br/><br/>
                        TEDxConegliano 2026 è lo spazio in cui ciò che appare uguale rivela qualcosa di completamente diverso.
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href="https://www.eventbrite.it/e/biglietti-tedxconegliano-palindromo-1982234216903" target="_blank">
                            <span className='button-52-light red m-auto'>
                                Acquista biglietto
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>SPEAKER</h5>
                            <p>
                                Voci e storie che cambiano direzione,
                                ribaltano prospettive e ci invitano a
                                rileggere ciò che pensavamo di conoscere.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={8} className='pb-5'>
                            <Row className='mt-5'>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={ElisabettaModena} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>ELISABETTA MODENA</p>
                                    <p className='text-muted'>
                                        Ricercatrice in Storia dell’arte contemporanea
                                        all’Università IULM di Milano, indaga l’incontro
                                        tra arti visive, media immersivi e cultura
                                        videoludica. Co-fondatrice di MoRE, esplora
                                        anche ciò che non si realizza, mostrando come
                                        le idee possano esistere oltre la loro forma.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={MassimoColomban} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>MASSIMO COLOMBAN</p>
                                    <p className='text-muted'>
                                        Partito come operaio a quattordici anni, è il
                                        fondatore di Permasteelisa, multinazionale
                                        leader negli involucri architettonici. Dopo aver
                                        raggiunto il successo, ha scelto di restituire
                                        valore attraverso nuovi progetti, tra
                                        imprenditoria, territorio e impegno filantropico.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={MariaRosaDiFazio} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>MARIA ROSA DI FAZIO</p>
                                    <p className='text-muted'>
                                        Responsabile di Oncologia Medica presso il
                                        Centro SH di San Marino, unisce ricerca e
                                        pratica clinica con un approccio centrato sulla
                                        persona. Integra terapie personalizzate e
                                        strategie innovative per rafforzare l’equilibrio
                                        del paziente e affrontare la malattia in modo
                                        sistemico.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={NicolaGirotti} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>NICOLA GIROTTI</p>
                                    <p className='text-muted'>
                                        In Pininfarina guida lo sviluppo di progetti di
                                        Product Design, unendo esperienza
                                        internazionale e visione strategica. Lavora per
                                        creare esperienze che combinano estetica,
                                        innovazione e performance, mettendo al centro
                                        le persone.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={AndreaImpiombato} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>ANDREA IMPIOMBATO ANDREANI</p>
                                    <p className='text-muted'>
                                        Designer e fondatore di Studio Andreani Spazi
                                        di Valore, progetta ambienti che influenzano
                                        emozioni e comportamenti. Attraverso la
                                        neuro-architettura trasforma percezioni e
                                        sensazioni in spazi capaci di generare
                                        benessere e relazione.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={PaoloCasarini} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>PAOLO CASARINI</p>
                                    <p className='text-muted'>
                                        Laureato in Fisica Teorica, affianca alla scrittura
                                        la creazione di progetti che nascono dal
                                        pensiero divergente. Con la sua azienda
                                        trasforma le idee in esperimenti narrativi e
                                        concettuali, tra ironia e immaginazione.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={GermanoMilite} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>GERMANO MILITE</p>
                                    <p className='text-muted'>
                                        Giornalista e direttore di young.it, dopo anni nel
                                        mondo corporate ha fondato Fufflix, progetto
                                        d’inchiesta sui business digitali. Analizza il web
                                        per smascherare truffe e pratiche scorrette,
                                        promuovendo un’informazione consapevole.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={DomingaLot} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>DOMINGA LOT</p>
                                    <p className='text-muted'>
                                        Parts Manager nel gruppo Carraro e arbitro
                                        internazionale FIVB, è stata la prima donna
                                        italiana a dirigere finali maschili ai massimi
                                        livelli. Una doppia carriera in cui leadership,
                                        determinazione e competenza si muovono tra
                                        azienda e sport.
                                    </p>
                                </Col>
                                <Col xs={6} lg={4} className='mb-5'>
                                    <Image src={MichelaPossamai} width={'100%'} />
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>MICHELA POSSAMAI</p>
                                    <p className='text-muted'>
                                        Filosofa e psicologa educativa, ha dedicato la
                                        sua carriera alla scuola e alla tutela delle
                                        persone, tra insegnamento, istituzioni e
                                        formazione. Oggi continua il suo impegno tra
                                        università e territorio, promuovendo reti di cura
                                        e attenzione verso l’altro.
                                    </p>
                                </Col>

                                {/* Intervento condiviso: 3 voci, una direzione */}
                                <Col xs={6} lg={4} className='mb-0'>
                                    <Image src={SaraFabbroni} width={'100%'} />
                                </Col>
                                <Col xs={6} lg={4} className='mb-0'>
                                    <Image src={GraziaGrena} width={'100%'} />
                                </Col>
                                <Col xs={6} lg={4} className='mb-0'>
                                    <Image src={SaraDallArmellina} width={'100%'} />
                                </Col>
                                <Col xs={12} className='mt-2 mb-5'>
                                    <p style={{ fontWeight: 600 }} className='lead mt-4 mb-1'>SARA FABBRONI, GRAZIA GRENA, SARA DALL’ARMELLINA</p>
                                    <p className='text-muted'>
                                        Sara Fabbroni, Grazia Grena e Sara Dall’Armellina portano sul palco tre voci, tre
                                        percorsi, un’unica direzione: trasformare il conflitto in possibilità. Dalla mediazione
                                        scolastica alla giustizia riparativa, fino a esperienze di vita che attraversano la storia,
                                        portano uno sguardo condiviso su responsabilità, dialogo e riconciliazione.
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-start'>
                        <Col xs={12} lg={3} className='pb-5'>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>27 Giugno 2026</h5>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={8} className='pb-5'>
                            <Row>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>ACCREDITI WORKSHOP</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>17:00</h2>
                                    <p className='text-muted small'>
                                        Accrediti riservati per possessori di
                                        biglietti con Workshop incluso.
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small '>WORKSHOP</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>17:30</h2>
                                    <p className='text-muted small'>
                                        Svolgimento workshop in piccoli gruppi.
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>ACCREDITI</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>18:00</h2>
                                    <p className='text-muted small'>
                                        Accrediti per tutti i biglietti.
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>TALK</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>19:00</h2>
                                    <p className='text-muted small'>
                                        TEDxConegliano Talks
                                    </p>
                                </Col>
                                <Col xs={12} lg={4} className='p-4' style={{ backgroundColor: '#f3f3f3', border: '10px solid #fff' }}>
                                    <p style={{ color: '#eb0028' }} className='lead mt-4 mb-1 small'>RINFRESCO E NETWORKING</p>
                                    <h2 style={{ fontWeight: 500, color: '#eb0028' }} className='mt-5'>21:00</h2>
                                    <p className='text-muted small'>
                                        Rinfresco serale di condivisione.
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 bg-slide height-100 slide-gradient-black' style={{ backgroundColor: '#eee', backgroundImage: 'url(' + castelloConegliano + ')' }}>
                <Container fluid="md" className='text-center p-5 text-white' style={{ zIndex: 1 }}>
                    <h5 style={{ fontWeight: 600, color: '#eb0028' }}>LOCATION</h5>
                    <h1 className='mt-5 mb-5'>
                        Castello di Conegliano
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Simbolo storico della città, il Castello di Conegliano attraversa il tempo conservando tracce di epoche, sguardi e significati diversi.
                        Oggi, sospeso tra memoria e nuove possibilità, diventa il luogo ideale per raccontare Palindromo.<br/>
                        Qui convivono passato e presente, punti di vista che si intrecciano e si trasformano.<br/>
                        Uno spazio che invita a rileggere ciò che conosciamo, scoprendo nuove direzioni nello stesso percorso.
                    </p>

                    <div className='mt-5 mb-5'>
                        <a href="https://www.eventbrite.it/e/biglietti-tedxconegliano-palindromo-1982234216903" target="_blank">
                            <span className='button-52-light red m-auto'>
                                Acquista biglietto
                            </span>
                        </a>
                    </div>

                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0 height-100'>
                <Container fluid="md" className='text-start p-5'>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={5}>
                            <h5 style={{ fontWeight: 600, color: '#eb0028' }}>TEDxConegliano</h5>
                            <p className='mt-5 mb-5 lead'>
                                Un luogo che attraversa il tempo.<br/>
                                Abbiamo scelto il Castello di Conegliano perché custodisce una parte profonda della storia della città.
                            </p>

                            <p className='mb-5'>
                                Nel corso dei secoli, questo spazio ha visto Conegliano trasformarsi, diventando un punto di
                                riferimento tra memoria, cultura e identità.<br/>
                                Oggi il Castello continua a essere un luogo capace di accogliere nuovi sguardi e nuove possibilità,
                                mantenendo vivo il legame tra ciò che è stato e ciò che sta diventando.
                                <br /><br />
                                Attraverso TEDxConegliano vogliamo valorizzare questo luogo, accendendo prospettive diverse
                                su uno spazio che da sempre invita a guardare oltre.<br/>
                                Perché ogni storia, come ogni idea, può rivelare significati nuovi a seconda del punto da cui la si osserva.
                            </p>
                        </Col>
                        <Col xs={12} lg={1}></Col>
                        <Col xs={12} lg={6} className='text-center'>
                            <Image src={castelloConegliano2} width={'100%'} />
                        </Col>
                    </Row>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#eb0028' }}>
                <Container fluid="md" className='text-center p-5 text-white'>
                    <h5>PARTNER</h5>
                    <h1 className='mt-5 mb-5 ms-auto me-auto' style={{ maxWidth: 760 }}>
                        I nostri partner, credono nel territorio e nei talenti che esso esprime.
                    </h1>

                    <p className='m-auto' style={{ maxWidth: 700 }}>
                        Con il loro sostegno, costruiamo insieme un futuro più luminoso, in cui la cultura è al centro del progresso e della crescita della comunità
                    </p>
                </Container>
            </Container>


            <Container fluid className='pt-5 pb-5 ps-0 pe-0'>
                <Container fluid="md" className='text-center p-5'>
                    <h5 style={{ color: '#eb0028' }}>CON IL PATROCINIO DI</h5>
                    <Row className='justify-content-center'>
                        {logos3.map((logo, i) => {
                            return (
                                <Col xs={6} md={2} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <h5 style={{ color: '#eb0028' }} className='mt-5'>I NOSTRI PARTNER</h5>

                    <Row className='justify-content-center'>
                        {logos0.map((logo, i) => {
                            return (
                                <Col xs={6} md={3} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <hr/>

                    <Row className='justify-content-center'>
                        {logos1.map((logo, i) => {
                            return (
                                <Col xs={6} md={3} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                    <hr/>

                    <Row className='justify-content-center'>
                        {logos2.map((logo, i) => {
                            return (
                                <Col xs={4} md={2} className='p-3' key={i}>
                                    <Image src={logo} width={'100%'} />
                                </Col>
                            )
                        })}
                    </Row>

                </Container>
            </Container>


            {/*
            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#eb0028' }} id="rivivi_evento">
                <Container fluid="md" className='text-center p-5 text-white'>
                    <h5>I TALK DI QUESTA EDIZIONE</h5>

                    <Row className='mt-5'>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="ZlvIhU_bH3E"
                                title="Alessandro Beccagli | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Da fragili e invisibili a protagonisti del proprio futuro | Alessandro Beccagli</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="JryRJFQDD2I"
                                title="Ezio Micelli | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>L’invisibile che costruisce le città | Ezio Micelli</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="CypYW9vkKDA"
                                title="Gian Luca Comandini | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Chi ha rubato il calcio ai bambini? | Gian Luca Comandini</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="qCe2k_C3VZg"
                                title="Laura Martin | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Diversa, non sbagliata. Il potere di riscrivere se stessi | Laura Martin</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="YM1aoc4uRQI"
                                title="Luciana Do Carmo | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Il tuo sogno può cambiare il mondo: la mia storia | Luciana Do Carmo</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="jXBnGywhFKw"
                                title="Giorgia Sterza | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>L’innovazione invisibile: vedere dove altri non guardano | Giorgia Sterza</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="wzLltPz_t7E"
                                title="Paolo Tagliamento | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>La Musica invisibile | Paolo Tagliamento</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="YPCIUMFMppc"
                                title="Andrea Da Re | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Il paradosso della realtà invisibile | Andrea Da Re</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="gRr-uCNosKU"
                                title="Camilla Ferrari | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>La fotografia apre portali invisibili | Camilla Ferrari</p>
                        </Col>
                        <Col sm={6} md={6} lg={4} className='mt-4'>
                            <LiteYouTubeEmbed
                                id="BL3Lxzvf41M"
                                title="Serena Fiorito | TEDxConegliano"
                                poster="maxresdefault"
                            />
                            <p className='mt-2 small'>Affrontare il dolore: il vero antidolorifico per tornare alla vita | Serena Fiorito</p>
                        </Col>
                    </Row>
                </Container>
            </Container>
            */}

            {/*
            <Container fluid className='pt-5 pb-5 ps-0 pe-0' style={{ background: '#fff' }} id="rivivi_evento">
                <Container fluid="md" className='text-center p-5 text-muted'>
                    <h5>RIVIVI L'EVENTO</h5>
                    <div className='mt-5'>
                        <LiteYouTubeEmbed
                            id="0CU_q0FwqAw"
                            title="TEDxConegliano - HERITAGE 2024"
                            poster="maxresdefault"
                            aspectHeight='140'
                            aspectWidth='384'
                        />
                    </div>
                </Container>
            </Container>
            */}

        </>
    );
};
